var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7502 30C16.4189 29.9955 16.1012 29.8673 15.8596 29.6406L7.10957 20.8906C6.91024 20.6478 6.80838 20.3394 6.82379 20.0256C6.8392 19.7118 6.97079 19.4149 7.19296 19.1928C7.41513 18.9706 7.71199 18.839 8.02581 18.8236C8.33962 18.8082 8.64795 18.91 8.89082 19.1094L16.7502 26.9844L33.3596 10.3594C33.6024 10.16 33.9108 10.0582 34.2246 10.0736C34.5384 10.089 34.8353 10.2206 35.0574 10.4428C35.2796 10.6649 35.4112 10.9618 35.4266 11.2756C35.442 11.5894 35.3401 11.8978 35.1408 12.1406L17.6408 29.6406C17.3992 29.8673 17.0815 29.9955 16.7502 30Z",
    fill: "#34C34D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0ae707af7f80e57e0035b9a496ff5edc.svg";
export { ForwardRef as ReactComponent };